import { success as successNotif, error as errorNotif } from "react-notification-system-redux";

import { ordersService } from "_services";

import { ordersTypes } from "../types";

export const ordersActions = {
  getOrders,
  getOrder,
  getFile,
  getFileFromProduct,
  postSpecimenUpdateProduct,
  putProduct,
  clearOrdersError,
  customerAction,
  putProductWithoutRefresh,
  postSpecimenUpdateProductWithoutRefresh,
  getSubscriptionsDetails,
  chargeUSPTOFee,
  feeRecharge,
};

function getOrders(params = {}) {
  const { withSubscriptions, ...restParams } = params;

  return (dispatch) => {
    dispatch(request());

    ordersService.getOrders({ category: "TRADEMARKS", page: 1, count: 100, ...restParams }).then(
      (orders) => dispatch(success(orders)),
      (error) => {
        if (!error.isResponse) {
          ordersService.crmGetOrders({ category: "TRADEMARKS", page: 1, count: 100, ...restParams }).then(
            (orders) => {
              dispatch(success(orders));

              if (withSubscriptions) {
                dispatch(getSubscriptionsDetails(orders));
              }
            },
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: ordersTypes.GET_ORDERS_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.GET_ORDERS_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.GET_ORDERS_FAILURE };
  }
}

function getOrder(orderId) {
  return (dispatch) => {
    dispatch(request());

    ordersService.getOrder(orderId).then(
      (orders) => dispatch(success(orders)),
      (error) => {
        if (!error.isResponse) {
          ordersService.crmGetOrder(orderId).then(
            (orders) => dispatch(success(orders)),
            (error) => {
              if (error !== "Illegal uid") {
                dispatch(errorNotif({ title: "Error", message: error }));
                dispatch(failure(null));
              } else {
                dispatch(failure(error.toString()));
              }
            }
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: ordersTypes.GET_ORDER_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.GET_ORDER_SUCCESS, payload };
  }
  function failure(error) {
    return { type: ordersTypes.GET_ORDER_FAILURE, error };
  }
}

function getSubscriptionsDetails(orders = []) {
  return (dispatch) => {
    dispatch(request());

    const subscriptionProducts = [];

    orders.forEach((order) => {
      order?.products?.forEach((product) => {
        if (product?.code?.subscription) {
          subscriptionProducts.push({ ...product, crmOrderId: order?.crmOrderId });
        }
      });
    });

    const requests = subscriptionProducts.map((product) =>
      ordersService.getSubscriptionDetails({ orderId: product?.orderId, productId: product?.id })
    );

    Promise.all(requests)
      .then((responses) => {
        const payload = responses.map((data, idx) => ({ ...data, product: subscriptionProducts[idx] }));
        dispatch(success(payload));
      })
      .catch((error) => {
        dispatch(failure());
        dispatch(errorNotif({ title: "Error", message: error.toString() }));
      });
  };

  function request() {
    return { type: ordersTypes.GET_SUBSCRIPTIONS_DETAILS_REQUEST };
  }

  function success(payload) {
    return { type: ordersTypes.GET_SUBSCRIPTIONS_DETAILS_SUCCESS, payload };
  }

  function failure() {
    return { type: ordersTypes.GET_SUBSCRIPTIONS_DETAILS_FAILURE };
  }
}

function getFile(orderId, fileId, useNameFromHeader = true) {
  return (dispatch) => {
    dispatch(request());

    ordersService.getFile(orderId, fileId, useNameFromHeader).then(
      () => {
        dispatch(success());
      },
      (error) => {
        if (!error.isResponse) {
          ordersService.crmGetFile(orderId, fileId).then(
            () => {
              dispatch(success());
            },
            () => {
              dispatch(failure());
              dispatch(
                errorNotif({
                  title: "Failure",
                  message: error.toString() || "An error occurred while downloading the file",
                })
              );
            }
          );
        } else {
          dispatch(failure());
          dispatch(
            errorNotif({
              title: "Failure",
              message: error.toString() || "An error occurred while downloading the file",
            })
          );
        }
      }
    );
  };

  function request() {
    return { type: ordersTypes.GET_ORDER_FILE_REQUEST };
  }
  function success() {
    return { type: ordersTypes.GET_ORDER_FILE_SUCCESS };
  }
  function failure() {
    return { type: ordersTypes.GET_ORDER_FILE_FAILURE };
  }
}

function getFileFromProduct(orderId, productId, fileType, useNameFromHeader = true) {
  return (dispatch) => {
    dispatch(request());

    ordersService.getFileFromProduct(orderId, productId, fileType, useNameFromHeader).then(
      () => {
        dispatch(success());
      },
      (error) => {
        if (!error.isResponse) {
          ordersService.crmGetFileFromProduct(orderId, productId, fileType).then(
            () => {
              dispatch(success());
            },
            () => {
              dispatch(
                errorNotif({
                  title: "Failure",
                  message: error.toString() || "An error occurred while downloading the file",
                })
              );
              dispatch(failure());
            }
          );
        } else {
          dispatch(
            errorNotif({
              title: "Failure",
              message: error.toString() || "An error occurred while downloading the file",
            })
          );
          dispatch(failure());
        }
      }
    );
  };

  function request() {
    return { type: ordersTypes.GET_ORDER_FILE_REQUEST };
  }
  function success() {
    return { type: ordersTypes.GET_ORDER_FILE_SUCCESS };
  }
  function failure() {
    return { type: ordersTypes.GET_ORDER_FILE_FAILURE };
  }
}

function putProduct({ orderId, productId, product, handleCallback }) {
  return async (dispatch) => {
    dispatch(request());

    ordersService.putProduct(productId, product).then(() => {
      dispatch(successNotif({ title: "Success", message: "Product was updated successful!" }));

      ordersService
        .getOrder(orderId)
        .then(
          (order) => dispatch(success(order)),
          (error) => dispatch(failure(error.toString()))
        )
        .catch((error) => {
          if (!error.isResponse) {
            ordersService
              .crmPutProduct(productId, product)

              .then(() => {
                dispatch(successNotif({ title: "Success", message: "Product was updated successful!" }));
                ordersService.crmGetOrder(orderId).then(
                  (order) => dispatch(success(order)),
                  (error) => dispatch(failure(error.toString()))
                );
              })
              .catch((error) => {
                dispatch(errorNotif({ title: "Failure", message: error.toString() }));
                dispatch(failure());
              });
          } else {
            dispatch(errorNotif({ title: "Failure", message: error.toString() }));
            dispatch(failure());
          }
        });
      handleCallback();
    });
  };

  function request() {
    return { type: ordersTypes.PUT_PRODUCT_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.PUT_PRODUCT_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.PUT_PRODUCT_FAILURE };
  }
}

function postSpecimenUpdateProduct({ orderId, productId, product, formData, fileType, handleCallback }) {
  return async (dispatch) => {
    dispatch(request());

    ordersService
      .postFile(orderId, productId, formData, fileType)
      .then(() => ordersService.putProduct(productId, product))
      .then(() => {
        dispatch(successNotif({ title: "Success", message: "Specimen was successfully uploaded!" }));
        ordersService.getOrder(orderId).then(
          (order) => dispatch(success(order)),
          (error) => dispatch(failure(error.toString()))
        );
        handleCallback();
      })
      .catch((error) => {
        if (!error.isResponse) {
          ordersService
            .crmPostFile(orderId, productId, formData, fileType)
            .then(() => ordersService.crmPutProduct(productId, product))
            .then(() => {
              dispatch(successNotif({ title: "Success", message: "Specimen was successfully uploaded!" }));
              ordersService.crmGetOrder(orderId).then(
                (order) => dispatch(success(order)),
                (error) => dispatch(failure(error.toString()))
              );
              handleCallback();
            })
            .catch((error) => {
              dispatch(errorNotif({ title: "Failure", message: error.toString() }));
              dispatch(failure());
            });
        } else {
          dispatch(errorNotif({ title: "Failure", message: error.toString() }));
          dispatch(failure());
        }
      });
  };

  function request() {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_FAILURE };
  }
}

function putProductWithoutRefresh({ productId, product, handleCallback }) {
  return async (dispatch) => {
    dispatch(request());

    ordersService.putProduct(productId, product).then(
      () => {
        handleCallback();
        dispatch(success());
        dispatch(successNotif({ title: "Success", message: "Product was updated successful!" }));
      },
      (error) => {
        dispatch(errorNotif({ title: "Failure", message: error.toString() }));
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_REQUEST };
  }
  function success() {
    return { type: ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_SUCCESS };
  }
  function failure() {
    return { type: ordersTypes.PUT_PRODUCT_WITHOUT_REFRESH_FAILURE };
  }
}

function postSpecimenUpdateProductWithoutRefresh({ orderId, productId, product, formData, fileType, handleCallback }) {
  return async (dispatch) => {
    dispatch(request());

    Promise.all([
      ordersService.postFile(orderId, productId, formData, fileType),
      ordersService.putProduct(productId, product),
    ]).then(
      () => {
        handleCallback();
        dispatch(successNotif({ title: "Success", message: "Specimen was successfully uploaded!" }));
        dispatch(success());
      },
      (error) => {
        dispatch(errorNotif({ title: "Failure", message: error.toString() }));
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_REQUEST };
  }
  function success() {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_SUCCESS };
  }
  function failure() {
    return { type: ordersTypes.POST_ORDER_SPECIMEN_WITHOUT_REFRESH_FAILURE };
  }
}

function clearOrdersError() {
  return { type: ordersTypes.GET_ORDER_CLEAR_ERROR };
}

function customerAction({ orderId, productId, actionType, message, notification, cb }) {
  return (dispatch) => {
    dispatch(request());

    ordersService.customerAction({ productId, actionType, message }).then(
      () => {
        cb && cb();

        dispatch(
          successNotif({
            title: "Success",
            message: notification || "Thank you! We will get your revision request over to our designers right away!",
            autoDismiss: 0,
          })
        );

        ordersService.getOrder(orderId).then(
          (order) => dispatch(success(order)),
          (error) => dispatch(failure(error.toString()))
        );
      },
      (error) => {
        dispatch(errorNotif({ title: "Failure", message: error.toString() }));
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: ordersTypes.CUSTOMER_ACTION_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.CUSTOMER_ACTION_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.CUSTOMER_ACTION_FAILURE };
  }
}

function chargeUSPTOFee({ orderId }) {
  return (dispatch) => {
    dispatch(request());

    ordersService.chargeUSPTOFee({ orderId }).then(
      () => {
        dispatch(
          successNotif({
            title: "Success",
            message: "Re-attempt charge of USPTO fee was successful!",
          })
        );

        ordersService.getOrder(orderId).then(
          (order) => dispatch(success(order)),
          (error) => dispatch(failure(error.toString()))
        );
      },
      (error) => {
        dispatch(errorNotif({ title: "Failure", message: error.toString() }));
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: ordersTypes.FEE_RECHARGE_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.FEE_RECHARGE_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.FEE_RECHARGE_FAILURE };
  }
}

function feeRecharge({ orderId, productId }) {
  return (dispatch) => {
    dispatch(request());

    ordersService.feeRecharge({ orderId, productId }).then(
      (data) => {
        if (data?.success) {
          dispatch(
            successNotif({
              title: "Success",
              message: data?.message || "Re-attempt charge of USPTO fee was successful!",
            })
          );

          ordersService.getOrder(orderId).then(
            (order) => {
              dispatch(success(order));
            },
            () => {
              dispatch(failure());
            }
          );
        } else {
          dispatch(
            errorNotif({
              title: "Failure",
              message: data?.message || "Re-attempt charge of USPTO fee failed!",
            })
          );

          dispatch(failure());
        }
      },
      (error) => {
        dispatch(errorNotif({ title: "Failure", message: error.toString() }));
        dispatch(failure());
      }
    );
  };

  function request() {
    return { type: ordersTypes.FEE_RECHARGE_REQUEST };
  }
  function success(payload) {
    return { type: ordersTypes.FEE_RECHARGE_SUCCESS, payload };
  }
  function failure() {
    return { type: ordersTypes.FEE_RECHARGE_FAILURE };
  }
}
